<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newBusCls">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newBusCls">Create New Business Class</v-toolbar-title>
          <v-toolbar-title v-else>Edit Business Class</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newBusCls">
                <v-text-field
                  v-model="busClsForm.busCls"
                  :label="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  v-validate="'required|param|max:4'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue">{{ busClsForm.busCls }}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.busClsDesc"
                  :label="labels.busClsDesc"
                  :error-messages="errors.collect('busClsDesc')"
                  data-vv-name="busClsDesc"
                  :data-vv-as="labels.busClsDesc"
                  v-validate="'required|entry|max:40'"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="busClsGrps"
                  v-model="busClsForm.busClsGrp"
                  :label="labels.busClsGrp"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busClsGrp"
                  :data-vv-as="labels.busClsGrp"
                  :error-messages="errors.collect('busClsGrp')"
                  clearable
                ></v-autocomplete>
                <!--
                <v-text-field v-model="busClsForm.busClsGrp" :label="labels.busClsGrp" :error-messages="errors.collect('busClsGrp')" data-vv-name="busClsGrp" :data-vv-as="labels.busClsGrp" append-icon="mdi-magnify" @click:append="getHelpList('busClsGrpList')" v-validate="helpListValidate('busClsGrp')" persistent-hint></v-text-field>
                -->
              </v-flex>
              <v-flex xs6 v-if="hideGlanCode">
                <v-autocomplete
                  :items="glACs"
                  v-model="busClsForm.glAC"
                  :label="labels.glAC"
                  item-text="label"
                  item-value="value"
                  data-vv-name="glAC"
                  :data-vv-as="labels.glAC"
                  :error-messages="errors.collect('glAC')"
                  clearable
                ></v-autocomplete>
                <!--
                <v-text-field v-model="busClsForm.glAC" :label="labels.glAC" :error-messages="errors.collect('glAC')" data-vv-name="glAC" :data-vv-as="labels.glAC" append-icon="mdi-magnify" @click:append="getHelpList('glanCodeList')" v-validate="helpListValidate('glAC')"></v-text-field>
                -->
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="busClsAppIdList"
                  v-model="busClsForm.busClsAppID"
                  :label="labels.busClsAppID"
                  item-text="label"
                  item-value="value"
                  data-vv-name="busClsAppID"
                  :data-vv-as="labels.busClsAppID"
                  :error-messages="errors.collect('busClsAppID')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  v-model="busClsForm.perGst"
                  :label="labels.perGst"
                  :error-messages="errors.collect('perGst')"
                  data-vv-name="perGst"
                  :data-vv-as="labels.perGst"
                  hide-details
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field
                  v-model="busClsForm.defTariff"
                  :label="labels.defTariff"
                  :error-messages="errors.collect('defTariff')"
                  data-vv-name="defTariff"
                  :data-vv-as="labels.defTariff"
                  append-icon="mdi-magnify"
                  @click:append="getHelpList('tariffList')"
                  v-validate="helpListValidate('defTariff')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="ifrsClsGrp"
                  v-model="busClsForm.ifrsClsGrp"
                  :label="labels.IFRSClsGrp"
                  item-text="label"
                  item-value="value"
                  data-vv-name="IFRSClsGrp"
                  :data-vv-as="labels.IFRSClsGrp"
                  :error-messages="errors.collect('IFRSClsGrp')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="portfolio"
                  v-model="busClsForm.portfolio"
                  :label="labels.portfolio"
                  item-text="label"
                  item-value="value"
                  data-vv-name="portfolio"
                  :data-vv-as="labels.portfolio"
                  :error-messages="errors.collect('portfolio')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-autocomplete
                  :items="giaClsGrp"
                  v-model="busClsForm.giaClsGrp"
                  :label="labels.GIAClsGrp"
                  item-text="label"
                  item-value="value"
                  data-vv-name="GIAClsGrp"
                  :data-vv-as="labels.GIAClsGrp"
                  :error-messages="errors.collect('GIAClsGrp')"
                  v-validate="'required|param'"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="subPortfolio"
                  v-model="busClsForm.subPortfolio"
                  :label="labels.subPortfolio"
                  item-text="label"
                  item-value="value"
                  data-vv-name="subPortfolio"
                  :data-vv-as="labels.subPortfolio"
                  :error-messages="errors.collect('subPortfolio')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-chart-areaspline</v-icon><span class="headerTitle">Accumulation</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="accumTypes"
                            v-model="busClsForm.accumType"
                            :label="labels.accumType"
                            item-text="label"
                            item-value="value"
                            data-vv-name="accumType"
                            :data-vv-as="labels.accumType"
                            :error-messages="errors.collect('accumType')"
                            clearable
                          ></v-autocomplete>
                          <!--
                        <v-text-field v-model="busClsForm.accumType" :label="labels.accumType" :error-messages="errors.collect('accumType')" data-vv-name="accumType" :data-vv-as="labels.accumType" append-icon="mdi-magnify" @click:append="getHelpList('accumTypeList')" v-validate="helpListValidate('accumType')"></v-text-field>
                        -->
                        </v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="ttyCesMethList"
                            v-model="busClsForm.ttyCesMeth"
                            :label="labels.ttyCesMeth"
                            item-text="label"
                            item-value="value"
                            data-vv-name="ttyCesMeth"
                            :data-vv-as="labels.ttyCesMeth"
                            :error-messages="errors.collect('ttyCesMeth')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="riCatList"
                            v-model="busClsForm.riCat"
                            :label="labels.riCat"
                            item-text="label"
                            item-value="value"
                            data-vv-name="riCat"
                            :data-vv-as="labels.riCat"
                            :error-messages="errors.collect('riCat')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-settings-box</v-icon><span class="headerTitle">Miscellaneous</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.vesYrMand"
                            :label="labels.vesYrMand"
                            :error-messages="errors.collect('vesYrMand')"
                            data-vv-name="vesYrMand"
                            :data-vv-as="labels.vesYrMand"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.perIndGrp"
                            :label="labels.perIndGrp"
                            :error-messages="errors.collect('perIndGrp')"
                            data-vv-name="perIndGrp"
                            :data-vv-as="labels.perIndGrp"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.perSubItem"
                            :label="labels.perSubItem"
                            :error-messages="errors.collect('perSubItem')"
                            data-vv-name="perSubItem"
                            :data-vv-as="labels.perSubItem"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.wrkmanComp"
                            :label="labels.wrkmanComp"
                            :error-messages="errors.collect('wrkmanComp')"
                            data-vv-name="wrkmanComp"
                            :data-vv-as="labels.wrkmanComp"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.prtFireRisk"
                            :label="labels.prtFireRisk"
                            :error-messages="errors.collect('prtFireRisk')"
                            data-vv-name="prtFireRisk"
                            :data-vv-as="labels.prtFireRisk"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.prtTotSi"
                            :label="labels.prtTotSi"
                            :error-messages="errors.collect('prtTotSi')"
                            data-vv-name="prtTotSi"
                            :data-vv-as="labels.prtTotSi"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-motorbike</v-icon><span class="headerTitle">Motor</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <!--
                      <v-flex xs6>
                        <v-autocomplete :items="vehGrps" v-model="busClsForm.vehGrp" :label="labels.vehGrp" item-text="label" item-value="value" data-vv-name="vehGrp" :data-vv-as="labels.vehGrp" :error-messages="errors.collect('vehGrp')" clearable></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field v-model="busClsForm.minAge" :label="labels.minAge" :error-messages="errors.collect('minAge')" v-int-mask="{intScale: 2}" data-vv-name="minAge" :data-vv-as="labels.minAge" v-validate="ageValidation('minAge')"></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field v-model="busClsForm.maxAge" :label="labels.maxAge" :error-messages="errors.collect('maxAge')" v-int-mask="{intScale: 2}" data-vv-name="maxAge" :data-vv-as="labels.maxAge" v-validate="ageValidation('maxAge')"></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-checkbox v-model="busClsForm.perTonnage" :label="labels.perTonnage" :error-messages="errors.collect('perTonnage')" data-vv-name="perTonnage" :data-vv-as="labels.perTonnage" hide-details></v-checkbox>
                      </v-flex>
                      -->
                        <v-flex xs6>
                          <v-autocomplete
                            :items="vehGrps"
                            v-model="busClsForm.vehGrp"
                            :label="labels.vehGrp"
                            item-text="label"
                            item-value="value"
                            data-vv-name="vehGrp"
                            :data-vv-as="labels.vehGrp"
                            :error-messages="errors.collect('vehGrp')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.defVehUsg"
                            :label="labels.defVehUsg"
                            :error-messages="errors.collect('defVehUsg')"
                            data-vv-name="defVehUsg"
                            :data-vv-as="labels.defVehUsg"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('vehUsgList')"
                            v-validate="helpListValidate('defVehUsg')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="busClsForm.giaVeh"
                            :label="labels.giaVeh"
                            :error-messages="errors.collect('giaVeh')"
                            data-vv-name="giaVeh"
                            :data-vv-as="labels.giaVeh"
                            v-validate="'entry|max:8'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.allowYr"
                            :label="labels.allowYr"
                            :error-messages="errors.collect('allowYr')"
                            data-vv-name="allowYr"
                            :data-vv-as="labels.allowYr"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-account-remove </v-icon><span class="headerTitle">Personal Accident</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="noLivesList"
                            v-model="busClsForm.noLive"
                            :label="labels.noLive"
                            item-text="label"
                            item-value="value"
                            data-vv-name="noLive"
                            :data-vv-as="labels.noLive"
                            :error-messages="errors.collect('noLive')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6>
                          <v-checkbox
                            v-model="busClsForm.nricMand"
                            :label="labels.nricMand"
                            :error-messages="errors.collect('nricMand')"
                            data-vv-name="nricMand"
                            :data-vv-as="labels.nricMand"
                            hide-details
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ busClsForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(busClsForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newBusCls">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ busClsForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(busClsForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
        <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
          Save
          <v-icon right>mdi-content-save </v-icon>
        </v-btn>
      </v-card>
      <v-dialog v-model="helpList" width="900px" persistent>
        <help-list :helpListID="helpListID" :busCls="busClsForm.busCls" @close="doClose" @doAssign="doAssign($event)"></help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
import {
  checkMaxAge,
  checkAgeMustEnter,
  checkHelpListField,
  checkVehGrp,
  busClsAppIdList,
  ttyCesMethList,
  riCatList,
  noLivesList,
  checkDefVehUsg
} from './BusClsCustomRuleAndList'
import HelpList from './HelpList'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
export default {
  data() {
    return {
      panel: [0, 0, 0, 0],
      labels: {
        // General
        busCls: 'Code',
        busClsDesc: 'Description',
        busClsGrp: 'Class Group',
        glAC: 'GL Analysis Code',
        busClsAppID: 'Application ID',
        perGst: 'Apply GST',
        IFRSClsGrp: 'IFRS Class Group',
        portfolio: 'Portfolio',
        GIAClsGrp: 'GIA Class Group',
        subPortfolio: 'Sub-Portfolio',
        // Accumulation
        accumType: 'Accumulation Type',
        ttyCesMeth: 'Treaty Cession Method',
        riCat: 'RI Category',
        // Miscellaneous
        vesYrMand: 'Make Vessel Year Built Mandatory',
        perIndGrp: 'Permit Industry Group',
        perSubItem: 'Permit SubItem',
        wrkmanComp: 'Workmen`s Compensation Class',
        prtFireRisk: 'Print Fire Risk Details',
        prtTotSi: 'Print Total Sum Insured',
        // Motor
        defTariff: 'Default Tariff',
        vehGrp: 'Default Vehicle Group',
        /* minAge: "Minimum Driver's Age",
        maxAge: "Maximum Driver's Age",
        perTonnage: 'Permit Tonnage',
        */
        defVehUsg: 'Default Vehicle Usage',
        allowYr: 'Allow Year for Motor Registration',
        giaVeh: 'GIA Vehicle Ref',
        // Personal Accident
        noLive: 'No. of Lives',
        nricMand: 'NRIC Mandatory',
        // Audit
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      busClsForm: {
        // General
        busCls: null,
        busClsDesc: null,
        busClsGrp: null,
        glAC: null,
        busClsAppID: null,
        perGst: false,
        ifrsClsGrp: null,
        portfolio: null,
        giaClsGrp: null,
        subPortfolio: null,
        // Accumulation
        accumType: null,
        ttyCesMth: null,
        riCat: null,
        // Miscellaneous
        vesYrMand: false,
        perIndGrp: false,
        perSubItem: false,
        wrkmanComp: false,
        prtFireRisk: false,
        prtTotSi: false,
        // Motor
        defTariff: null,
        vehGrp: null,
        /* minAge: 0,
        maxAge: 0,
        perTonnage: false,
        */
        defVehUsg: null,
        allowYr: false,
        giaVeh: null,
        // Personal Accident
        noLive: null,
        nricMand: false,
        // Audit
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedName: null,
        modifiedDate: null
      },
      helpList: false,
      helpListID: '',
      busClsGrpList: [],
      glanCodeList: [],
      accumTypeList: [],
      tariffList: [],
      vehGrpList: [],
      busClsAppIdList: [],
      ttyCesMethList: [],
      riCatList: [],
      noLivesList: [],
      giaClsGrp: [],
      ifrsClsGrp: [],
      portfolio: [],
      subPortfolio: [],
      newBusCls: false,
      hideGlanCode: true,
      loading: false,
      submitting: false,
      sideFunction: [
        {
          text: 'Permit Benefit',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'pmtBenefitPerBusClsList' }
        },
        {
          text: 'Permit Tariff',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'pmtTariffPerBusCls',
            params: { incomingBusCls: 'noBusCls', incomingTariff: 'noTariff', incomingBusClsDesc: 'noBusClsDesc', incomingTariffDesc: 'noTariffDesc' }
          }
        },
        {
          text: 'GIA Class Group',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'giaClsGrp'
          }
        },
        {
          text: 'IFRS Class Group',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'ifrsClsGrp'
          }
        },
        {
          text: 'Portfolio',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'portfolio'
          }
        },
        {
          text: 'Sub-Portfolio',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: {
            name: 'subPortfolio'
          }
        }
      ],
      busClsGrps: [],
      glACs: [],
      accumTypes: [],
      vehGrps: [],
      vehUsgList: []
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    helpListValidate(field) {
      var IdList = []
      var i = 0
      if (field === 'busClsGrp') {
        for (i in this.busClsGrpList) {
          IdList.push(this.busClsGrpList[i].value)
        }
      } else if (field === 'glAC') {
        for (i in this.glanCodeList) {
          IdList.push(this.glanCodeList[i].value)
        }
      } else if (field === 'accumType') {
        for (i in this.accumTypeList) {
          IdList.push(this.accumTypeList[i].value)
        }
      } else if (field === 'defTariff') {
        for (i in this.tariffList) {
          IdList.push(this.tariffList[i].value)
        }
      } else if (field === 'defVehUsg') {
        for (i in this.vehUsgList) {
          IdList.push(parseInt(this.vehUsgList[i].value))
        }
      } else if (field === 'vehGrp') {
        for (i in this.vehGrpList) {
          IdList.push(parseInt(this.vehGrpList[i].value))
        }
      }

      if (field === 'vehGrp') {
        return 'checkVehGrp:' + IdList + '|numeric'
      } else if (field === 'defVehUsg') {
        return 'checkDefVehUsg:' + IdList + '|numeric'
      } else if (field === 'glAC') {
        return 'required|checkHelpListField:' + IdList
      } else {
        return 'checkHelpListField:' + IdList
      }
    },
    ageValidation(field) {
      const minAge = this.busClsForm.minAge
      const maxAge = this.busClsForm.maxAge
      var validate = 'numeric|'
      var maxMinVal = '|mask_min_value:16|mask_max_value:99'
      if (minAge > 0 && minAge !== '' && maxAge > 0 && maxAge !== '') {
        if (field === 'minAge') {
          return validate + 'checkMaxAge:' + maxAge + maxMinVal
        } else {
          return validate + maxMinVal
        }
      } else if (minAge > 0 && (maxAge === 0 || maxAge === '')) {
        if (field === 'minAge') {
          return validate + 'checkAgeMustEnter' + maxMinVal
        } else {
          return validate + maxMinVal
        }
      } else if ((minAge === 0 || minAge === '') && maxAge > 0) {
        if (field === 'maxAge') {
          return validate + 'checkAgeMustEnter' + maxMinVal
        } else {
          return validate + maxMinVal
        }
      } else {
        return ''
      }
    },
    async doFetch() {
      const apiURI = this.busClsMenu.getBusCls
      if (apiURI) {
        this.loading = true
        try {
          const expand = { busCls: this.busCls }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // General
            this.busClsForm.busCls = data.busCls.busCls
            this.busClsForm.busClsDesc = data.busCls.busClsDesc
            this.busClsForm.busClsGrp = data.busCls.busClsGrp
            this.busClsForm.glAC = data.busCls.glAC
            this.busClsForm.busClsAppID = data.busCls.busClsAppID
            this.busClsForm.perGst = data.busCls.perGst
            // Accumulation
            this.busClsForm.accumType = data.busCls.accumType
            this.busClsForm.ttyCesMeth = data.busCls.ttyCesMeth
            this.busClsForm.riCat = data.busCls.riCat
            // Miscellaneous
            this.busClsForm.vesYrMand = data.busCls.vesYrMand
            this.busClsForm.perIndGrp = data.busCls.perIndGrp
            this.busClsForm.perSubItem = data.busCls.perSubItem
            this.busClsForm.wrkmanComp = data.busCls.wrkmanComp
            this.busClsForm.prtFireRisk = data.busCls.prtFireRisk
            this.busClsForm.prtTotSi = data.busCls.prtTotSi
            // Motor
            this.busClsForm.defTariff = data.busCls.defTariff
            this.busClsForm.vehGrp = data.busCls.vehGrp
            /* this.busClsForm.minAge = data.busCls.minAge
            this.busClsForm.maxAge = data.busCls.maxAge
            this.busClsForm.perTonnage = data.busCls.perTonnage
            */
            this.busClsForm.defVehUsg = data.busCls.defVehUsg
            this.busClsForm.giaVeh = data.busCls.giaVeh
            this.busClsForm.allowYr = data.busCls.allowYr
            // Personal Accident
            this.busClsForm.noLive = data.busCls.noLive
            this.busClsForm.nricMand = data.busCls.nricMand
            // Audit
            this.busClsForm.createdName = data.busCls.createdName
            this.busClsForm.createdDate = data.busCls.createdDate
            this.busClsForm.modifiedName = data.busCls.modifiedName
            this.busClsForm.modifiedDate = data.busCls.modifiedDate

            // GIA
            this.busClsForm.giaClsGrp = data.busCls.giaClsGrp

            // IFRS
            this.busClsForm.ifrsClsGrp = data.busCls.ifrsClsGrp

            // PORTFOLIO
            this.busClsForm.portfolio = data.busCls.portfolio

            // SUBPORTFOLIO
            this.busClsForm.subPortfolio = data.busCls.subPortfolio

            // Put SideFunction Param
            for (var i = 0; i < this.sideFunction.length; i++) {
              if (this.sideFunction[i].params.name === 'pmtTariffPerBusCls') {
                this.sideFunction[i].params.params.incomingBusCls = data.busCls.busCls
                this.sideFunction[i].params.params.incomingTariff = 'noTariff'
                this.sideFunction[i].params.params.incomingBusClsDesc = data.busCls.busClsDesc
                this.sideFunction[i].params.params.incomingTariffDesc = 'noTariffDesc'
              }
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCheckHideGlanCode() {
      const apiURI = this.busClsMenu.chkHideGlanCode
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          if (data) {
            this.hideGlanCode = data.hideGlanCode
          }
        } catch (err) {
          this.hideGlanCode = true
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSetList() {
      const getState = this.$store.state.busClsParam
      this.busClsGrpList = getState.busClsGrpList
      this.glanCodeList = getState.glanCodeList
      this.accumTypeList = getState.accumTypeList
      this.tariffList = getState.tariffList
      this.vehGrpList = getState.vehGrpList
      this.busClsAppIdList = busClsAppIdList
      this.ttyCesMethList = ttyCesMethList
      this.riCatList = riCatList
      this.noLivesList = noLivesList
      this.vehUsgList = getState.vehUsgList
    },
    getHelpList(field) {
      this.helpListID = field
      this.helpList = true
    },
    doClose() {
      this.helpList = false
      this.busClsGrpHelpList = false
    },
    doAssign(e) {
      if (this.helpListID === 'busClsGrpList') {
        this.busClsForm.busClsGrp = e
      } else if (this.helpListID === 'glanCodeList') {
        this.busClsForm.glAC = e
      } else if (this.helpListID === 'accumTypeList') {
        this.busClsForm.accumType = e
      } else if (this.helpListID === 'tariffList') {
        this.busClsForm.defTariff = e
      } else if (this.helpListID === 'vehUsgList') {
        this.busClsForm.defVehUsg = parseInt(e)
      } else {
        this.busClsForm.vehGrp = parseInt(e)
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newBusCls) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.busClsMenu.createBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.busClsForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'busClsList' })
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.busClsMenu.updateBusCls
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.busClsForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'busClsList' })
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.$router.push({ name: 'busClsList' })
    },
    async getDataList(param) {
      const apiUrl = this.busClsMenu.dataList
      if (apiUrl) {
        const params = {
          paramName: param
        }
        const result = await this.$http.get(expandURI(apiUrl, params))
        if (result.data.dataList) {
          this.$set(this, param, result.data.dataList)
        }
      }
    }
  },
  computed: {
    busCls() {
      return this.$route.params.busCls
    },
    busClsMenu() {
      return this.$store.state.busClsParam.menu
    },
    outgoingBusCls() {
      return this.busClsForm.busCls
    }
  },
  created() {
    this.doCheckHideGlanCode()
    this.doSetList()
    this.getDataList('busClsGrps')
    this.getDataList('glACs')
    this.getDataList('accumTypes')
    this.getDataList('vehGrps')
    this.getDataList('giaClsGrp')
    this.getDataList('ifrsClsGrp')
    this.getDataList('portfolio')
    this.getDataList('subPortfolio')
    if (this.busCls === 'new') {
      this.newBusCls = true
    } else {
      this.doFetch()
    }
    this.$validator.extend('checkMaxAge', checkMaxAge)
    this.$validator.extend('checkAgeMustEnter', checkAgeMustEnter)
    this.$validator.extend('checkHelpListField', checkHelpListField)
    this.$validator.extend('checkVehGrp', checkVehGrp)
    this.$validator.extend('checkDefVehUsg', checkDefVehUsg)
  },
  mixins: [MessageMixin],
  components: {
    HelpList,
    SideFunctionMenu
  }
}
</script>
